module.exports = __webpack_public_path__ + "images/category_lp/common/medal-flat_bc95a5647ef1afcca0c043be707c1837.png";